<template>
    <div>
        <el-row>
            <el-col>
                <div class="table-grd notification-tbl">
                    <div class="header">
                        <h1>{{ $t('Notifications') }}</h1>
                    </div>
                    <v-collapse-group ref="group1">
                        <v-collapse-wrapper ref="toggle_second">
                            <div class="my-content table-desc">
                                <el-table :data="notifications.data" @sort-change="handleSortChange" fit highlight-current-row key='aTable'>
                                    <el-table-column :label="$t('No.')" type="index" :index="indexMethod" width="60" fixed></el-table-column>
                                    <el-table-column :label="$t('Actions')" width="90" fixed>
                                        <template slot-scope="scope">
                                            <ul class="act-list">
                                                <li>
                                                    <a href="javascript:void(0);" @click="handleDelete(scope.$index, scope.row)"><i class=" icon-delete"></i></a>
                                                </li>
                                            </ul>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Created at')" sortable="custom" prop="created_at" width="250">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.created_at"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip :label="$t('Message')" prop="notification_message" width="300">
                                    </el-table-column>
                                    <el-table-column min-width="10"></el-table-column>
                                </el-table>
                                <el-pagination v-if="notifications.meta.total" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filterData.page" :page-sizes="[6, 12, 24, 66, 111]" :page-size="filterData.pageLength" layout="sizes, slot, ->, prev, pager, next" :total="notifications.meta.total">
                                    <template>
                                        <span class="page-no">
                                            {{ $t('Showing out of records',{'0': notifications.data.length, '1': notifications.meta.total}) }}
                                            </span>
                                    </template>
                                </el-pagination>
                            </div>
                        </v-collapse-wrapper>
                    </v-collapse-group>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filterData: {
                    page: 1,
                    pageLength: process.env.KIPAKI_pageLength,
                    sortBy: "id",
                    order: "desc",
                    alphaColumn: null,
                    alpha: null,
                },
                notifications: {
                    meta: {},
                    data: []
                },
            };
        },
        mounted() {
            this.getNotifications();
        },
        methods: {
            getNotifications() {
                request({
                        url: "user-notifications",
                        method: "get",
                        params: this.filterData
                    })
                    .then(response => {
                        this.notifications = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            handleDelete(index, row) {
                request({
                        url: "user-notifications/" + row.id,
                        method: "delete",
                        data: {}
                    })
                    .then(response => {
                        this.getNotifications();
                        this.$notify({
                            title: this.$t('Success'),
                            message: response.data.message,
                            type: "success",
                            offset: 50
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            },
            handleCurrentChange(event) {
                this.getNotifications(this.filterData.current_page);
            },
            handleSizeChange(event) {
                this.filterData.pageLength = event;
                this.getNotifications();
            },
            handleSortChange(event) {
                this.filterData.sortBy = event.prop;
                if (event.order === "ascending") this.filterData.order = "asc";
                else if (event.order === "descending") this.filterData.order = "desc";
                else {
                    this.filterData.sortBy = "id";
                    this.filterData.order = "desc";
                }
                this.getNotifications();
            },
            indexMethod(index) {
                return index + this.filterData.pageLength * this.filterData.page - this.filterData.pageLength + 1
            },
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/Notifications/Notifications.vue